import React, { useState } from "react";

import { useDashboardContext } from "../../../contexts/dashboard-context";
import { useKeyDown } from "../../../hooks/useKeyboard";
import { useLabels } from "../../../hooks/useLabels";
import { useIsProductAdvancedEditMode } from "../../../hooks/useIsProductAdvancedEditMode";
import { useCopyPasteZone } from "../../../hooks/useCopyPasteZone";
import { useArrowKeyZoneMove } from "../../../hooks/useArrowKeyZoneMove";
import { useLogicalSelectedPage, useSelectedZone } from "../../../hooks/useSelection";
import { isDeleteSymbolZoneSupported } from "../../bottom-menu-panels/symbols/menu-info";
import { ZoneDepthDropdown } from "../../zone-depth-dropdown/zone-depth-dropdown";
import { Tooltip } from "../../tooltip/tooltip";
import { TopMenu } from "../top-menu";
import { labels } from "./labels";

export function SymbolTopMenu() {
	const selectedZone = useSelectedZone();
	const selectedPage = useLogicalSelectedPage();
	const symbolZone = eXpress.core.isSymbolZone(selectedZone) ? selectedZone : undefined;

	const dashboard = useDashboardContext();
	const isAdvancedEditModeEnabled = useIsProductAdvancedEditMode();

	const canDelete = isDeleteSymbolZoneSupported(symbolZone, dashboard);
	const canChangeZoneDepth = isAdvancedEditModeEnabled;

	const [openDepthDropDown, setOpenDepthDropDown] = useState(false);

	const [[deleteText]] = useLabels([labels.deleteTooltip]);

	// Register Ctrl+C/V for the selected symbol zone.
	useCopyPasteZone({
		zone: symbolZone,
		destinationPage: selectedPage ?? undefined,
	});

	useArrowKeyZoneMove({ zone: symbolZone });

	useKeyDown((event) => {
		if (event.key === "Delete" && symbolZone && canDelete) {
			dashboard.removeZone(symbolZone);
		}
	});

	if (!symbolZone) return null;
	if (!canChangeZoneDepth && !canDelete) return null;

	return (
		<TopMenu.Root>
			<TopMenu.Bar>
				{canChangeZoneDepth && (
					<TopMenu.Group
						hideLevel={2}
						onVisibilityChange={(isVisible) => {
							if (!isVisible) setOpenDepthDropDown(false);
						}}
					>
						<ZoneDepthDropdown
							open={openDepthDropDown}
							onOpenChange={setOpenDepthDropDown}
						/>
					</TopMenu.Group>
				)}

				{canDelete && (
					<Tooltip text={deleteText}>
						<TopMenu.Icon
							iconName="bin"
							disabled={!canDelete}
							onClick={() => {
								if (symbolZone) dashboard.removeZone(symbolZone);
							}}
						/>
					</Tooltip>
				)}
			</TopMenu.Bar>
		</TopMenu.Root>
	);
}
